import { render } from "./NewElementModal.vue?vue&type=template&id=091c7ac4&scoped=true"
import script from "./NewElementModal.vue?vue&type=script&lang=js"
export * from "./NewElementModal.vue?vue&type=script&lang=js"

import "./NewElementModal.vue?vue&type=style&index=0&id=091c7ac4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091c7ac4"]])

export default __exports__